/* EndPageLabel.tsx generated by @compiled/babel-plugin v0.29.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _11 = "._80omtlke{cursor:pointer}";
const _10 = "._19bvidpf{padding-left:0}";
const _9 = "._n3tdidpf{padding-bottom:0}";
const _8 = "._u5f3idpf{padding-right:0}";
const _7 = "._ca0qidpf{padding-top:0}";
const _6 = "._1wyb1j6v{font-size:1rem}";
const _5 = "._19itglyw{border:none}";
const _4 = "._11q7glyw{background:none}";
const _3 = "._syaz1qtk{color:var(--ds-link)}";
import { BodyNormal } from '@atlassian/mpac-primitives';
import React from 'react';
const _2 = "._19pkoahv{margin-top:var(--ds-space-600,3pc)}";
const _ = "._y3gn1h6o{text-align:center}";
const Label = forwardRef((_ref, __cmplr) => {
  let {
      as: C = BodyNormal,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_y3gn1h6o _19pkoahv", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Label.displayName = 'Label';
}
const BackToSearchButton = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "button",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_3, _4, _5, _6, _7, _8, _9, _10, _11]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_syaz1qtk _11q7glyw _19itglyw _1wyb1j6v _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _80omtlke", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  BackToSearchButton.displayName = 'BackToSearchButton';
}
const EndPageLabel = _ref3 => {
  let {
    onLinkClick
  } = _ref3;
  return /*#__PURE__*/React.createElement(Label, null, "Couldn\u2019t find what you were looking for? Try rephrasing", ' ', /*#__PURE__*/React.createElement(BackToSearchButton, {
    onClick: onLinkClick
  }, "your search query"), ".");
};
export default EndPageLabel;